import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";
import { COMPANY, AREAS, SERVICES, BBB } from "@/content";
import CallLink from "@/components/CallLink";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-sage text-bone">
      <div className="mx-auto max-w-7xl px-5 md:px-10 py-16 md:py-20 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="mb-6">
            <img src="/logo.png" alt="Juli Klein's A/C Services, LLC" className="h-20 w-auto [filter:drop-shadow(0_1px_6px_rgba(255,255,255,0.5))]" />
          </div>
          <p className="text-bone/70 max-w-md leading-relaxed">{COMPANY.tagline} Repairing and servicing all air conditioning makes and models across Southwest Florida — year-round.</p>
          <CallLink data-testid="footer-call-btn" className="mt-6 inline-flex items-center gap-2 rounded-full bg-terracotta px-6 py-3 font-semibold text-bone hover:bg-terracotta-dark transition-colors duration-200">
            <Phone size={16} /> Call {COMPANY.phone}
          </CallLink>
          <a href={BBB.profileUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-bbb-badge"
            className="mt-6 flex items-center gap-4 rounded-2xl bg-white/95 p-3 pr-5 w-fit shadow-sm hover:-translate-y-0.5 transition-transform duration-200">
            <img src={BBB.seal} alt="BBB Accredited Business" className="h-14 w-auto" />
            <span className="leading-tight">
              <span className="block font-heading text-2xl text-sage">{BBB.rating} Rated</span>
              <span className="block text-[11px] uppercase tracking-widest text-ink">BBB Accredited since {BBB.accreditedSince}</span>
            </span>
          </a>
        </div>
        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-bone/60 mb-4">Services</h4>
          <ul className="space-y-2.5">
            {SERVICES.map((s) => (
              <li key={s.slug}><Link to={`/services/${s.path}`} data-testid={`footer-service-${s.slug}`} className="text-bone/85 hover:text-bone transition-colors duration-200">{s.title}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-bone/60 mb-4">Service Areas</h4>
          <ul className="space-y-2.5">
            {AREAS.map((a) => (
              <li key={a} className="flex items-center gap-2 text-bone/85"><MapPin size={14} className="text-terracotta" /> {a}, FL</li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-bone/15">
        <div className="mx-auto max-w-7xl px-5 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-bone/60">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} {COMPANY.full}, LLC. All rights reserved.</span>
          <span data-testid="footer-license" className="text-center">Veteran-Owned · Licensed &amp; Insured · FL Lic. {BBB.license}</span>
          <Link to="/admin" data-testid="footer-admin-link" aria-label="Team access" title="Team access" className="text-bone/25 hover:text-bone/70 transition-colors duration-200 select-none">•</Link>
        </div>
      </div>
    </footer>
  );
}
